<template>
  <section>
    <div class="card">
      <h4 class="mx-3 mt-2">
        {{ $t("lang.onBoarding.summary_of_responses") }}
      </h4>
      <div class="card-body mt-2 scroll-class">
        <div v-for="item in substepsdata">
          <EditInline
            @save="save"
            class="mt-4"
            :value="item.value"
            :value2="item.value2"
            :value3="item.value3"
            :subStep="item.substep"
            :productName="item.productName"
            :disabled="onBoarding.target_status_id == 4 ? true : false"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import EditInline from "@/components/Onboarding/EditInline.vue";

export default {
  data() {
    return {
      productName: false,
      substepsdata: []
    };
  },

  computed: {
    ...mapState({
      onBoarding: state => state.onboarding
    })
  },

  components: {
    EditInline
  },
  created() {
    if (
      this.onBoarding.productName == "" ||
      this.onBoarding.productName == null ||
      this.onBoarding.productName == undefined
    ) {
      this.productName = "[" + this.$t("lang.token.product_name") + "]";
    } else {
      this.productName = this.onBoarding.productName;
    }

    this.substepsdata = [
      {
        substep: 3,
        value: "what_we_created",
        value2: false,
        value3: false,
        productName: this.productName
      },
      {
        substep: 4,
        value: "we_propose",
        value2: false,
        value3: false,
        productName: this.productName
      },
      {
        substep: 5,
        value: "we_are_convinced",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 6,
        value: "in_few_words",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 7,
        value: "we_wanted_to_exchange_about",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 8,
        value: "the_idea_is_simple",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 9,
        value: "we_were_wondering_how",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 10,
        value: "prospect_area",
        value2: false,
        value3: false,
        productName: ""
      },
      {
        substep: 11,
        value: "argument_1",
        value2: "argument_2",
        value3: "argument_3",
        productName: ""
      },
      {
        substep: 12,
        value: "ref_1",
        value2: "ref_2",
        value3: "ref_3",
        productName: ""
      }
    ];
  },

  methods: {
    save() {
      this.$emit("save");
    }
  }
};
</script>
<style>
.fix-height {
  max-height: 440px;
  overflow-y: scroll;
}

.scroll-class {
  max-height: 600px;
  overflow-y: auto;
}
</style>
